import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {InputLabel, Stack, styled} from '@mui/material'

export const InputWithLabelWrapper = styled(Stack, {
  shouldForwardProp: prop => prop !== 'width',
})(({width}) => ({
  width: (width as number) ?? 'auto',
}))

export const Label = styled(InputLabel)(({theme}) => ({
  textAlign: 'start',
  color: theme.palette.grey[100],
  ...theme.typography.body1,
}))

export const LabelAndTooltipWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: 5,
  alignItems: 'center',
}))

export const TooltipIcon = styled(InfoOutlinedIcon)(({theme}) => ({
  fontSize: 20,
  color: theme.palette.grey[100],
}))
